
import { io } from 'socket.io-client';

const isProduction = process.env.NODE_ENV === 'production';

const SOCKET_URL = isProduction
  ? process.env.REACT_APP_SOCKET_URL?.replace('http', 'wss') || 'wss://swlogis.it.kr'
  : 'ws://localhost:4000';

export const socket = io(SOCKET_URL, {
  transports: ['websocket'],
});

// 연결/해제 로그 추가
socket.on('connect', () => {
  console.log('[소켓] 연결됨', socket.id, SOCKET_URL);
});
socket.on('disconnect', () => {
  console.log('[소켓] 연결 끊김');
});
